import { useState, useCallback } from 'react';
import { EditingState } from '../../../Comment/redux/types';

type ReplyState = { [key in number]: boolean };

export function useReplyState() {
  const [replyingComments, setReplyingComments] = useState<ReplyState>({});

  const onEditingStateChange = useCallback(
    (commentId: number, state: EditingState) => (replyState: ReplyState) => {
      const { [commentId]: value, ...rest } = replyState;
      if (state === 'replying') {
        setReplyingComments({ ...rest, [commentId]: true });
      } else {
        setReplyingComments(rest);
      }
    },
    []
  );

  const isReplyingToComment = useCallback(
    parentId => !!replyingComments[parentId],
    [replyingComments]
  );

  return {
    onEditingStateChange,
    isReplyingToComment,
  };
}
